import React, { useState } from 'react';
import { useAuth } from './AuthContext';
import { Ikon } from './Ikon';
import './Login.css';

export default function Login() {
  const { girisYap } = useAuth();
  const [form, setForm] = useState({ kullaniciAdi: '', sifre: '' });
  const [hata, setHata] = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.kullaniciAdi.trim() || !form.sifre) { setHata('Kullanıcı adı ve şifre gereklidir.'); return; }
    setYukleniyor(true);
    const sonuc = await girisYap(form.kullaniciAdi.trim(), form.sifre);
    if (!sonuc.basarili) {
      setHata(sonuc.hata || 'Kullanıcı adı veya şifre hatalı.');
      setYukleniyor(false);
    }
  };

  return (
    <div className="login-sayfa">
      <div className="login-sol">
        <div className="login-logo">
          <span className="login-logo-ikon"><Ikon ad="kutu" boyut={28} /></span>
          <span className="login-eyebrow">Envanter Yönetim Sistemi</span>
          <h1>StokTakip</h1>
          <p>Şirket envanteri, gerçek zamanlı tek panelde</p>
        </div>
        <div className="login-ozellikler">
          <div className="ozellik"><span>Anlık stok takibi</span></div>
          <div className="ozellik"><span>Kişiye özel işlem geçmişi</span></div>
          <div className="ozellik"><span>Kritik stok uyarıları</span></div>
          <div className="ozellik"><span>Grafikler & Excel raporu</span></div>
        </div>
      </div>

      <div className="login-sag">
        <div className="login-kart">
          <div className="login-kart-baslik">
            <h2>Giriş Yap</h2>
            <p>Devam etmek için hesabınıza giriş yapın</p>
          </div>
          <form onSubmit={handleSubmit} className="login-form">
            <div className="login-form-grup">
              <label>Kullanıcı Adı</label>
              <div className="input-kap">
                <span className="input-ikon"><Ikon ad="kisi" boyut={15} /></span>
                <input
                  type="text"
                  placeholder="kullanıcı adınızı girin"
                  value={form.kullaniciAdi}
                  onChange={e => { setForm(p => ({ ...p, kullaniciAdi: e.target.value })); setHata(''); }}
                  autoFocus
                />
              </div>
            </div>
            <div className="login-form-grup">
              <label>Şifre</label>
              <div className="input-kap">
                <span className="input-ikon"><Ikon ad="kilit" boyut={15} /></span>
                <input
                  type="password"
                  placeholder="şifrenizi girin"
                  value={form.sifre}
                  onChange={e => { setForm(p => ({ ...p, sifre: e.target.value })); setHata(''); }}
                />
              </div>
            </div>
            {hata && <div className="login-hata">{hata}</div>}
            <button type="submit" className="login-btn" disabled={yukleniyor}>
              {yukleniyor ? 'Giriş yapılıyor...' : 'Giriş Yap'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
